import React, { useEffect } from 'react';
import gsap from 'gsap';
import { PLAYER, RESOURCES } from '../data';
import iconMap from '../iconMap';

// Map basic colors to Tailwind classes
const getColorClass = (color) => {
  const colorMap = {
    blue: 'text-blue-400',
    yellow: 'text-yellow-400',
    green: 'text-green-400',
    red: 'text-red-400',
    purple: 'text-purple-400',
    orange: 'text-orange-400',
    // Add more color mappings as needed
  };

  return colorMap[color?.toLowerCase()] || 'text-blue-400'; // Default fallback
};

function RewardModal({ app, rewards, onClose }) {
  useEffect(() => {
    const tl = gsap.timeline();

    // Flash animation
    tl.fromTo('.reward-area',
      { backgroundColor: 'rgba(255, 255, 255, 1)' },
      {
        backgroundColor: 'rgba(255, 255, 255, 0)',
        duration: 0.45,
        ease: 'power2.out'
      }
    );

    // Original reward items animation
    tl.from('.reward-item', {
      y: -20,
      scale: 0,
      opacity: 0,
      duration: 0.3,
      stagger: 0.4,
      ease: 'back.out(1.7)'
    });
  }, []);

  const handleClaim = () => {
    // Update player resources
    Object.entries(rewards).forEach(([type, amount]) => {
      PLAYER.resources[type] += amount;
    });
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-50">
      <div className="reward-area w-full py-8 bg-gradient-to-r from-transparent via-black/80 to-transparent">
        <div className="flex justify-center gap-12 mb-8 px-4">
          {Object.entries(rewards).map(([type, amount], index) => {
            console.log(type);
            const resource = RESOURCES[type];
            const IconComponent = iconMap[resource.id];

            // Convert basic color to Tailwind class
            const colorClass = getColorClass(resource.color);

            return (
              <div
                key={type}
                className="reward-item flex flex-col items-center"
              >
                <div className="bg-gradient-to-b from-white/10 to-white/5 p-8 rounded-2xl mb-3">
                  <IconComponent
                    size={48}
                    className={colorClass}
                  />
                </div>
                <div className="text-white text-center">
                  <div className="text-2xl font-bold">×{amount}</div>
                  <div className="text-sm opacity-70">
                    {resource.name}
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <div className="flex justify-center">
          <button
            onClick={handleClaim}
            className="px-12 py-3 rounded-full bg-white text-black font-bold hover:bg-gray-100 transition-colors"
            style={{ fontFamily: 'Norse' }}
          >
            Claim
          </button>
        </div>
      </div>
    </div>
  );
}

export default RewardModal;